<template>
  <LoadMore :load="fetch" name="events">
    <template v-slot:default="{ items, response, isLoaded }">
      <Watermark
        :repeat="1"
        :text="product.watermarkLabel"
        v-if="response.isSample"
        :className="$i18n.locale === 'et' ? 'top-15' : ''" />
      <table class="table structure-table structure-table-borders" role="tablist" v-if="isLoaded">
        <thead>
          <tr class="consent-table-header">
            <th class="d-none d-xl-table-cell">{{ $t('monitoring.labels.date') }}</th>
            <th class="d-none d-xl-table-cell">{{ $t('monitoring.labels.types') }}</th>
            <th class="d-none d-xl-table-cell">{{ $t('monitoring.labels.content') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in items" :key="item.description">
            <tr :rowspan="item.description ? 2 : null">
              <td>
                <span class="td-header d-block d-xl-none">{{ $t('monitoring.labels.date') }}</span>
                {{ $date(item.date) }}
              </td>
              <td>
                <span class="td-header d-block d-xl-none">{{ $t('monitoring.labels.types') }}</span>
                {{ item.type }}
              </td>
              <td class="mobile-border">
                <span class="td-header d-block d-xl-none">{{ $t('monitoring.labels.content') }}</span>
                <a
                  class="collapsed"
                  href="#"
                  @click.prevent="togglePanelAt(index)"
                  v-b-toggle="`${index}-details`"
                  v-if="item.description"
                >
                  <div v-html="item.content" class="reset-p d-inline" />
                  <span class="icon-arrow-down32 gray float-end" />
                  <span class="icon-arrow-up32 gray float-end" />
                </a>
                <div v-else v-html="item.content" class="reset-p d-inline" />
              </td>
            </tr>
            <tr :key="`${index}-details`" v-if="item.description">
              <td colspan="3" :class="isOpenPanelAt(index) ? 'card-body mobile-border' : 'no-border'">
                <BCollapse :id="`${index}-details`" accordion="notification" class="fade">
                  <p v-html="item.description" />
                </BCollapse>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <Spinner v-else />
      <div class="alert alert-default mb-7" role="alert" v-if="isLoaded && items.length === 0">
        {{ $t('monitoring.emptyList') }}
      </div>
    </template>
  </LoadMore>
</template>

<script>
import { mapActions } from 'vuex';
import { BCollapse } from 'bootstrap-vue-next';
import Watermark from './Watermark';
import LoadMore from './LoadMore';
import Spinner from './Spinner';

export default {
  props: ['product'],
  components: {
    BCollapse,
    Watermark,
    LoadMore,
    Spinner,
  },
  data: () => ({
    isSample: true,
    visible: {},
  }),
  methods: {
    ...mapActions('product', ['getMyMonitoringEvents']),

    isOpenPanelAt(index) {
      if (!(index in this.visible)) {
        this.visible[index] = false;
      }

      return this.visible[index];
    },

    togglePanelAt(index) {
      this.visible[index] = !this.visible[index];
    },

    fetch(params) {
      return this.getMyMonitoringEvents(params)
        .then((response) => {
          this.isSample = response.isSample;
          return response;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-border {
    padding: 0;
    border: 0;
  }
  .top-15 {
    top: 15rem!important;
  }
</style>
